// src/features/oio/errors/components/WarningBanner.tsx
import { useEffect } from "react"
import { AlertTriangle, X } from "lucide-react"

interface WarningBannerProps {
  message: string
  onDismiss: () => void
}

export function WarningBanner({ message, onDismiss }: WarningBannerProps) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, 8000)
    return () => clearTimeout(timer)
  }, [onDismiss])

  return (
    <div className="mx-3 my-1 flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50 px-4 py-2 text-amber-800">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
      <p className="flex-1 text-xs">{message}</p>
      <button onClick={onDismiss} aria-label="Dismiss">
        <X className="h-3.5 w-3.5 opacity-60 hover:opacity-100" />
      </button>
    </div>
  )
}
